module.exports = __webpack_public_path__ + "static/img/video_conferencing.e89cd77c.png";